import { Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
export interface Quotation {
  quotation_id: string;
  expire_on: string;
  status: string;
  travel_dates: string;
  destination: string;
  source: string;
}
@Component({
  selector: 'app-quotation-list',
  templateUrl: './quotation-list.component.html',
  styleUrls: ['./quotation-list.component.scss']
})
export class QuotationListComponent {
  myQuotationList: Quotation[] = [
    {
      "quotation_id": "QA000123982",
      "expire_on": "08/05/2024",
      "status": "Valid",
      "travel_dates": "12/05/2024 - 20/05/2024",
      "destination": "United Arab Emirates(UAE), Oman, Kuwait",
      "source": "Direct"
    },
    {
      "quotation_id": "QA000128293",
      "expire_on": "07/05/2024",
      "status": "Valid",
      "travel_dates": "14/05/2024 - 20/05/2024",
      "destination": "Singapore, Malaysia",
      "source": "Intermediary"
    },
    {
      "quotation_id": "QA000193829",
      "expire_on": "30/04/2024",
      "status": "Expired",
      "travel_dates": "09/05/2024 - 18/05/2024",
      "destination": "Hong Kong, Thailand",
      "source": "B2C"
    }
  ]
  displayedColumns: string[] = ['quotation_id', 'expire_on', 'status', 'travel_dates', 'destination', 'source'];
  dataSource = new MatTableDataSource<Quotation>(this.myQuotationList);

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private router: Router,
  ) {

  }

  ngOnInit() {
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  quotationInfo(quotationId: any) {
    // this.router.navigate(['quotation-premium',quotationId]);
  }
  goBack() {
    this.router.navigate(['quotation/get-quote']);
  }
}
